export enum SnackbarType {
	Success = 'succes',
	Warning = 'warning',
	Error = 'error',
	Mute = 'mute',
}
